<template>
  <div
    v-if="isSiteSelected && isTreeSelected"
    class="content"
  >
    <p class="noYPadding mb-0 text">
      {{ $t(`copySite.step3.select`) }}
    </p>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.graphics"
          :label="$t('copySite.step3.graphics')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding copySite">
        <VCheckbox
          v-model="data.alerts"
          :label="$t('copySite.step3.alerts')"
          outlined
          solo
          flat
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
  <div
    v-else
    class="text-center"
  >
    <p
      v-if="!isSiteSelected"
      class="noYPadding text"
    >
      {{ $t(`copySite.selectSite`) }}
    </p>
    <p
      v-if="isSiteSelected && !isTreeSelected"
      class="noYPadding text"
    >
      {{ $t(`copySite.selectTree`) }}
    </p>
  </div>
</template>

<script>
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
    name: 'Others',
    components: {
        VCheckbox,
    },
    props: {
        others: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'selectedSite',
            'selectedTree',
        ]),
        isSiteSelected() {
            return !!(this.selectedSite && this.selectedSite.id);
        },
        isTreeSelected() {
            const rootElementNoSelected = this.selectedTree?.children.every(node => !node.isSelected);
            return !rootElementNoSelected;
        },
    },
    watch: {
        others: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.others) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { others: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.text {
    font-size: 18px;
}
.content {
    padding: 0 25%;
}
</style>
